import * as yup from 'yup';

export const newBrasSchema = yup.object({
  nombre: yup.string().required('Campo requerido'),
  direccion: yup.string().required('Campo requerido'),
  coordenadas: yup.string().required('Campo requerido'),
  radius: yup.string().required('Campo requerido'),
  hostname: yup.string().required('Campo requerido'),
  password: yup.string().required('Campo requerido'),
  modelo: yup.string().optional(),
  estado: yup.boolean().optional(),
});